import { useEffect, useState } from "react"
import UMCDomainContentLayout from "../common/UMCDomainContentLayout"
import { useDispatch, useSelector } from "react-redux"
import { checkIfAnyModified, deepMergeObjects, findInObjectById, getDomainsView, replaceLinkPhAndApplyJLogic, updateObjByObj, validateLinks, updateValueById } from "../../utils/SchemaParseUtils"
import { UUM_URL, DIRECTORY_SYNCHRO_URL } from "../../utils/Config"
import { setDisableCreateBtn, setProfileDetailData, setUserDetailData, setUserDetailSchema, setDirectorySynchroDetailedData, setUserSCIMId, setCreateUserFromDirectorySynchro, setCurrentUserSCIMIndex, setIsCompareSyncwithOXE, setDnNumberFromFreeRange,setIsDirSynchro } from "../../store/reducers/UUMReducer"
import { getSchemaDataResponse, getTableSchema } from "../../store/actions/CommonActions"
import { setBaseMergeData, setContentLoading, setCurrentMergedData, setIsUnSavedDataExists, setUmcNotification, setValidateState, setBaseDIrectoryMergedData, setCurrDirectoryMergedData } from "../../store/reducers/CommonReducer"
import { CREATE, UPDATE, OXE_ERROR } from "../../utils/Constants"
import { validateAllMandatoryAttr } from "../../utils/ValidationUtils"
import { createUser, deleteUser, getUserData, updateUser, deleteDirectoryUsers, getDirectrySynchroUserData, addDirectrySynchroComments, getDirectrySynchroCompareData } from "../../store/actions/UUMActions"
import confirmModal from "../common/confirmModal"
import UMCButton from "../common/UMCButton"
import _ from "lodash"
import { getTranslated } from "../../utils/CommonUtils"
import UMCCheckbox from "../common/UMCCheckbox"
import { InfoCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import { getProfileData } from "../../store/actions/UUMActions"
import { showOxeErrorsByCodesInDialog } from "../../store/actions/OxeActions";
import { getRequest } from "../../utils/RequestActions"
import { parseRefAPI } from "../../utils/CommonUtils"
import { sendGTMEvent } from "../../utils/GTMUtils"

const CreateUserDetailView = (props) => {

    const [domains, setDomains] = useState([])
    const [isReadOnly, setIsReadOnly] = useState(false)
    const [profileType, setProfileType] = useState()
    const [isChecked, setIsChecked] = useState(false)

    const [dnRefApiCalled, setDnRefApiCalled] = useState(false)
    const [dnValue, setDnValue] = useState("")

    const userDetailSchema = useSelector(state => state.uum.userDetailSchema)
    const profileDetailData = useSelector(state => state.uum.profileDetailData)
    const userDetailData = useSelector(state => state.uum.userDetailData)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const currDirectoryMergedData = useSelector((state) => state.common.currDirectoryMergedData)
    const baseDIrectoryMergedData = useSelector((state) => state.common.baseDIrectoryMergedData)
    const validateState = useSelector((state) => state.common.validateState)
    const disableCreateBtn = useSelector(state => state.uum.disableCreateBtn)
    const dict = useSelector((state) => state.common.dict)
    const isUnSavedDataExists = useSelector((state) => state.common.isUnSavedDataExists)
    const directorySynchroDetailedData = useSelector((state) => state.uum.directorySynchroDetailedData)
    const userSCIMId = useSelector((state) => state.uum.userSCIMId)
    const currentUserSCIMIndex = useSelector(state => state.uum.currentUserSCIMIndex)
    const directorySychroUserDN = useSelector((state) => state.uum.directorySychroUserDN)
    const directorySynchroCompareTableSchema = useSelector((state) => state.uum.directorySynchroCompareTableSchema)
    const directorySynchroCompareDetailedData = useSelector((state) => state.uum.directorySynchroCompareDetailedData)
    const isCompareSyncwithOXE = useSelector((state) => state.uum.isCompareSyncwithOXE)
    const isReplaceButtonClicked = useSelector((state) => state.uum.isReplaceButtonClicked)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!Object.keys(userDetailSchema).length) {
            const request = { url: `${UUM_URL}/schema/detail/easyuser`, action: setUserDetailSchema }
            dispatch(getSchemaDataResponse(request))
        }

        if (props.directorySynchroMode === "CHECK") {
            dispatch(setContentLoading(true))
            dispatch(getDirectrySynchroCompareData(userSCIMId, directorySychroUserDN))
        }

        return (() => {
            dispatch(setCurrentMergedData(null))
            dispatch(setProfileDetailData(null))
            dispatch(setUserDetailData(null))
        })
    }, [])

    useEffect(() => {
        if (props.mode === CREATE && props.selectedProfile) {
            dispatch(getProfileData(props.selectedProfile, true, (response) => {
                handleProfileDataErrResp(response)
            }))

            const userSCIMIdArray = Array.isArray(userSCIMId) ? userSCIMId : (userSCIMId ? [userSCIMId] : []);
            if (props.isFromDirectorySynchro && Array.isArray(userSCIMIdArray) && userSCIMIdArray.length > 0) {
                const currentId = userSCIMIdArray[currentUserSCIMIndex]
                const request = { url: `${DIRECTORY_SYNCHRO_URL}/directorySynchro/users/${currentId}`, action: setDirectorySynchroDetailedData }
                dispatch(getSchemaDataResponse(request))
                dispatch(setIsDirSynchro(true))
            }
        } else if (props.mode === UPDATE && props.selectedUser) {

            if (props.isFromDirectorySynchro && props.directorySynchroMode === "MODIFY") {
                const directorySynchroSCIMID = userSCIMId
                const directrySynchroDN = directorySychroUserDN
                dispatch(setContentLoading(true))
                dispatch(getDirectrySynchroUserData(directorySynchroSCIMID, directrySynchroDN))
            }
            else dispatch(getUserData(props.selectedUser))
        }
    }, [props.selectedProfile, props.isFromDirectorySynchro, props.directorySynchroDetailedData, userSCIMId, currentUserSCIMIndex])

    useEffect(() => {
        if (!props.isFromDirectorySynchro) {
            setDomains(currentMergedData)
            dispatch(setIsUnSavedDataExists(checkIfAnyModified(currentMergedData)))
        } else {
                if(props.directorySynchroMode === "CHECK"){
                     setDomains(currDirectoryMergedData)
            dispatch(setIsUnSavedDataExists(checkIfAnyModified(currDirectoryMergedData)))
                }else{
                    setDomains(currentMergedData)
            dispatch(setIsUnSavedDataExists(checkIfAnyModified(currentMergedData)))
                } 
        } 
    }, [currentMergedData, currDirectoryMergedData])

    useEffect(() => {
        baseMergeData && dispatch(setContentLoading(false))
    }, [baseMergeData])

    const getDNValueFromCurrentMergeData = () => {
        return findInObjectById(currentMergedData, "directorynumber")
    }

    const getRefApiFreeNumber = () => {

        getRequest({ url: parseRefAPI(getDNValueFromCurrentMergeData().refApi.apiurl) }, (res, status) => {
            if (status && res?.value !== undefined) {
                setDnValue(res?.value)//store value
                setDnRefApiCalled(true)//set flag
            } else {
                // handle failure scenario
                console.log("ref api failed")
            }
        })
    }
    useEffect(() => {
        if (currentMergedData !== null && (dnRefApiCalled === false)) {
            getRefApiFreeNumber()
        }
    }, [currentMergedData])

    useEffect(() => {
        if (dnValue !== null && dnRefApiCalled)
            hardCodeDnInCurrentMergeddata()

    }, [dnValue, dnRefApiCalled])

    const hardCodeDnInCurrentMergeddata = () => {
        const attribute = getDNValueFromCurrentMergeData() // this will give DN object
        handleSchemaDataChange(attribute, dnValue)//sending the object to change, and the value to be replaced
    }

    const handleSchemaDataChange = (attribute, value) => {
        dispatch(setDnNumberFromFreeRange(value))
        const mergedData = currentMergedData
        if (mergedData) {
            let tempObj = _.cloneDeep(mergedData)
            const foundObj = findInObjectById(baseMergeData, attribute.id)
            tempObj = updateValueById(tempObj, attribute.id, value, foundObj)
            tempObj = tempObj?.obj
            setCurrentMergedData(tempObj)
        }
    }

    useEffect(() => {
        if (props.mode === CREATE && userDetailSchema?.domain && profileDetailData?.domain) {
            const attrLinkVal = findInObjectById(profileDetailData.domain, "umcsettype")
            const filteredSchema = applySDomainLevelLinksOnCreate(userDetailSchema.domain, [attrLinkVal])
            const mergedData = updateObjByObj(filteredSchema, profileDetailData.domain)
            let updatedData = validateLinks(mergedData)

            //  If directorySynchro data is present, merge it
            if (props.isFromDirectorySynchro && directorySynchroDetailedData !== null) {
                // const normalizedResponse = normalizeApiResponse(directorySynchroDetailedData);
                const mergedWithDirectory = deepMergeObjects(updatedData, directorySynchroDetailedData?.domain)
                // if(newdata!== null)setMergedWithDirectory(newdata)
                updatedData = validateLinks(mergedWithDirectory)
            }

            dispatch(setCurrentMergedData(updatedData))
            dispatch(setBaseMergeData(updatedData))

            // handle profile type logic
            const profiletypeData = findInObjectById(updatedData, "profiletype")
            if (profiletypeData?.value) {
                setProfileType(profiletypeData.value)
                if (profiletypeData.value === "DECT") {
                    dispatch(setDisableCreateBtn(true))
                }
            }
        }
    }, [userDetailSchema, profileDetailData, directorySynchroDetailedData, props.mode, props.isFromDirectorySynchro])


    useEffect(() => {
        if (userDetailSchema?.domain && userDetailData?.domain) {
            const filteredSchema = filterSubdomain(userDetailSchema.domain, userDetailData.domain)
            const mergedData = deepMergeObjects(filteredSchema, userDetailData.domain)
            const updatedData = validateLinks(mergedData)
            dispatch(setCurrentMergedData(updatedData))
            dispatch(setBaseMergeData(updatedData))

            // const profiletypeData = findInObjectById(updatedData, "profiletype")
            // if (profiletypeData?.value) {
            //     setProfileType(profiletypeData.value)
            // }
            // dispatch(setContentLoading(false))
        }
    }, [userDetailSchema, userDetailData])

    useEffect(() => {
        if (directorySynchroCompareTableSchema?.domain && directorySynchroCompareDetailedData?.domain) {
            // dataStatic.domain
            const filteredDirectorySynchoroSchema = filterSubdomain(directorySynchroCompareTableSchema.domain, directorySynchroCompareDetailedData.domain)
            const mergedDirectorySynchoroData = deepMergeObjects(filteredDirectorySynchoroSchema, directorySynchroCompareDetailedData.domain)
            const updatedDirectorySynchoroData = validateLinks(mergedDirectorySynchoroData)

            dispatch(setCurrDirectoryMergedData(updatedDirectorySynchoroData))
            dispatch(setBaseDIrectoryMergedData(updatedDirectorySynchoroData))

        }
    }, [directorySynchroCompareTableSchema, directorySynchroCompareDetailedData])

    useEffect(() => {
        if (profileType === "DECT") {
            setIsReadOnly(!disableCreateBtn) // Set global ReadOnly on DECT register success
        }
    }, [disableCreateBtn])


    const filterSubdomain = (schema, data) => {
        if (schema?.length && data?.length) {
            let schemaTemp = _.cloneDeep(schema)
            const filteresSubDomains = schemaTemp[0]?.subdomain.filter(item => data[0]?.subdomain.some(data => data.id === item.id))
            schemaTemp[0].subdomain = filteresSubDomains
            return schemaTemp
        }

        return schema
    }

    const applySDomainLevelLinksOnCreate = (domain, attributesWithIsLink) => {
        const tempDomain = _.cloneDeep(domain)

        tempDomain[0].subdomain = tempDomain[0].subdomain.filter(
            ({ link }) => link === undefined || replaceLinkPhAndApplyJLogic(link, attributesWithIsLink)
        )

        return tempDomain
    }

    const applySubDomainLevelLinks = (domain, attributesWithIsLink) => {
        let obj = _.cloneDeep(domain)
        if (Array.isArray(obj)) {
            // Filter out objects with visible: "false"
            return obj.filter((item) => (item.link === undefined || replaceLinkPhAndApplyJLogic(item.link, attributesWithIsLink))).map((item) => applySubDomainLevelLinks(item, attributesWithIsLink))
        } else if (typeof obj === "object" && obj !== null) {
            // Iterate over keys in the object
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (key === "attribute") {
                        obj[key].forEach(attr => {
                            if (attr.hasOwnProperty("link")) {
                                const status = replaceLinkPhAndApplyJLogic(attr.link, attributesWithIsLink)
                                attr.visible = status // Add the 'visible' property
                            }
                        })
                    } else {
                        obj[key] = applySubDomainLevelLinks(obj[key], attributesWithIsLink) // Recursively process nested objects
                    }
                }
            }
        }
        return obj
    }

    const getHeaderView = () => {
        return (
            (props.directorySynchroMode === "CHECK") ?
                <div className="inner-tab-hd-container" style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <UMCCheckbox
                        checked={isCompareSyncwithOXE}
                        handleChange={(value) => {
                            dispatch(setIsCompareSyncwithOXE(value))
                            setIsChecked(value)
                        }}
                        label={getTranslated(dict, "LABEL_OXE_LINK")}
                    />
                    <Tooltip title={getTranslated(dict, "LABEL_LINK_DS_OXE_TOOLTIP")}>
                        <InfoCircleFilled className="radio-info-icon" role="icon" />
                    </Tooltip>
                </div>
                :
                <UMCButton label={getTranslated(dict, "LABEL_DELETE")} className="delete" onClick={() => { props.handleUserDelete(props.selectedUser) }} />
        )
    }

    const HandleOK = async () => {
        const validateResponse = async (status, data) => {
            if (status) {
                if (!props.isFromDirectorySynchro) {
                    props.backToListView(true)
                } else {
                    const currentId = userSCIMId[currentUserSCIMIndex]
                    let dn = currentMergedData[0]?.subdomain[0]?.attribute[4]?.value
                    if (typeof (userSCIMId) === "object") {
                        const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/deleteUsers`
                        await dispatch(addDirectrySynchroComments([currentId], dn))
                        await dispatch(deleteDirectoryUsers(url, [currentId]))
                        if (currentUserSCIMIndex < userSCIMId.length - 1) {
                            dispatch(setContentLoading(false))
                            dispatch(setCurrentUserSCIMIndex(currentUserSCIMIndex + 1))
                            props.changeCreateMode(true)
                            dispatch(setCurrentMergedData(null))
                        } else {
                            dispatch(setCreateUserFromDirectorySynchro(false))
                            dispatch(setContentLoading(false))
                            dispatch(setCurrentUserSCIMIndex(0))
                            dispatch(setCurrentMergedData(null))

                            dispatch(setDnNumberFromFreeRange(''))
                            dispatch(setIsDirSynchro(false))

                            props.selectedRows([])
                            dispatch(setUmcNotification({
                                type: "success",
                                message: getTranslated(dict, "LABEL_SAVED"),
                                description: ""
                            }))
                        }
                    } else {
                        if (props.mode === "CREATE"){
                            await dispatch(addDirectrySynchroComments(userSCIMId, dn))
                            props.selectedRows([])
                        }
                        const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/deleteUsers`
                        await dispatch(deleteDirectoryUsers(url, [userSCIMId]))
                        dispatch(setCreateUserFromDirectorySynchro(false))
                        dispatch(setContentLoading(false))
                        dispatch(setCurrentMergedData(null))

                        dispatch(setDnNumberFromFreeRange(''))
                        dispatch(setIsDirSynchro(false))

                        dispatch(setUmcNotification({
                            type: "success",
                            message: getTranslated(dict, "LABEL_SAVED"),
                            description: ""
                        }))
                    }
                }
            } else {
                dispatch(setContentLoading(false))
                if (data?.errorResponse?.[0]?.errorType === OXE_ERROR) {
                    dispatch(showOxeErrorsByCodesInDialog(data));
                }
                else {
                    confirmModal({
                        title: "LABEL_FAILED",
                        content: data?.errorMessage || "",
                        type: "error",
                        okText: "LABEL_OK"
                    })
                }
                // dispatch(setUmcNotification({
                //     type: "error",
                //     message: "Failed",
                //     description: data?.errorMessage || ""
                // }))
            }
        }

        if (props.mode === CREATE && profileType === "DECT") { // Redirect to List view if DECT, as the user is already created on Validate button click
            validateResponse(true)
            sendGTMEvent({
                event: "umc_easy_user_config",
                action: "User creation completed"
            })
        } else {
            let validateStatus = validateAllMandatoryAttr(currentMergedData, baseMergeData) // Returns the validated obj if success, else returns false
            if (props.directorySynchroMode === "CHECK" && isCompareSyncwithOXE === true) {
                const clonedValidateStatus = JSON.parse(JSON.stringify(validateStatus))
                const clonedDirectoryData = JSON.parse(JSON.stringify(currDirectoryMergedData))
                const commentObjects = clonedDirectoryData[0].subdomain[0].attribute.filter(attr =>
                    ["comment4"].includes(attr.id)
                )
                const commentObjectswithModifiedValue = [{ ...commentObjects[0], isModified: true }]
                const identifySubdomain = clonedValidateStatus[0].subdomain.find(sub => sub.id === "identify")

                if (identifySubdomain && identifySubdomain.attribute) {
                    identifySubdomain.attribute = [
                        ...identifySubdomain.attribute,
                        ...commentObjectswithModifiedValue
                    ]
                }
                validateStatus = clonedValidateStatus
            }

            if (validateStatus) {
                dispatch(setValidateState(false))
                dispatch(setContentLoading(true))
                if (props.mode === UPDATE) {
                    dispatch(updateUser(props.selectedUser, validateStatus, (status, data) => {
                        validateResponse(status, data)
                    }))
                    props.directorySynchroMode !== "MODIFY" && props.directorySynchroMode !== "CHECK" && sendGTMEvent({ // Trigger only for normal user update, not for DS modify/check
                        event: "umc_easy_user_config",
                        action: "User update triggered"
                    })
                } else if (props.mode === UPDATE && props.directorySynchroMode === "MODIFY") {
                    dispatch(updateUser(props.selectedUser, validateStatus, (status, data) => {
                        validateResponse(status, data)
                    }))
                } else if (props.mode === UPDATE && props.directorySynchroMode === "CHECK") {
                    dispatch(updateUser(props.selectedUser, validateStatus, (status, data) => {
                        validateResponse(status, data)
                    }))
                }
                else {
                    dispatch(createUser((status, data) => {
                        validateResponse(status, data)
                        sendGTMEvent({
                            event: "umc_easy_user_config",
                            action: "User creation completed"
                        })
                    }))
                }
            } else {
                dispatch(setValidateState(true))
            }
        }
    }

    const goBackHandler = () => {
        if (currentMergedData && isUnSavedDataExists) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    validateForDECTReturn()
                    props.changeCreateMode(true)
                }
            })
        } else {
            props.changeCreateMode(true)
        }
    }

    const validateForDECTReturn = () => {
        if (props.mode === CREATE && profileType === "DECT") {
            const dnAttr = findInObjectById(currentMergedData, "dectdirectorynumber")
            dnAttr.value && dispatch(deleteUser(dnAttr.value, (status) => {
                if (!status) {
                    console.log("DECT: Deletion failed")
                }
            }))
            dispatch(setCurrentMergedData(null))
        } else {
            dispatch(setCurrentMergedData(null))
        }
    }

    const handleProfileDataErrResp = (response) => {
        if (response?.errorResponse?.length > 0 || response?.errorMessage) {
            dispatch(setContentLoading(false));
            confirmModal({
                title:
                    response.errorResponse?.length > 0
                        ? getTranslated(dict, response.errorResponse[0]?.message)
                        : getTranslated(dict, "LABEL_FAILED"),
                content: response.errorMessage || "",
                type: "error",
                okText: "LABEL_OK",
                onOk: () => { props.changeCreateMode(true); }
            })
        }
    }

    const buttonOnLogic = () =>{
        if(props.directorySynchroMode === "MODIFY")
            return false;
        else if(props.directorySynchroMode === "CHECK" && (isChecked || isReplaceButtonClicked))
            return false;
        
        return (disableCreateBtn || !isUnSavedDataExists)
    }

    return <>
        <UMCDomainContentLayout
            header={(props.mode === UPDATE && props.directorySynchroMode !== "MODIFY") || props.directorySynchroMode === "CHECK" ? getHeaderView() : null}
            domains={getDomainsView(domains, { validateState: validateState, actionMode: props.mode, isReadOnly: isReadOnly })}
            backBtnLabel="LABEL_BACK"
            okBtnLabel={props.mode === UPDATE ? (props.directorySynchroMode === "CHECK") ? "LABEL_SAVE" : "LABEL_UPDATE" : "LABEL_CREATE"}
            //disablOKBtn={props.directorySynchroMode === "MODIFY" || props.directorySynchroMode === "CHECK" ? false : (disableCreateBtn || !isUnSavedDataExists)}
            disablOKBtn={ buttonOnLogic() }
            goBackHandler={() => goBackHandler()}
            handleOK={() => HandleOK()}
        />
    </>
}

export default CreateUserDetailView